var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"residency"},[_c('h1',[_vm._v("Residents:")]),_c('div',{staticClass:"grid pt-lg"},_vm._l((_vm.orderedProfiles),function(profile){return _c('profile-cell',{key:profile.id,attrs:{"profile":profile}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }